<template>
    <div class="AdminProject pa-3">
        <v-card class="pa-3">
            <h2>Campaign - User</h2>
            <v-layout>
                <v-autocomplete
                    hide-details
                    clearable
                    :label="this.$filters.capitalize($t('project'))"
                    style="max-width: 400px"
                    class="mr-3"
                    :search-input.sync="searchKey"
                    :items="campaignList"
                    item-text="title"
                    item-value="id"
                    v-model="campaign"
                ></v-autocomplete>
                <v-btn color="primary" @click="exportProjectUser">
                    Download excel
                </v-btn>
            </v-layout>
        </v-card>
    </div>
</template>

<script>
import AdminService from '@/services/admin.service'
import CampaignService from '@/services/campaign.service'

export default {
    name: "AdminCampaignList",
    data () {
        return {
            campaignList: [],
            searchKey: '',
            campaign: ''
        }
    },
    mounted () {
        this.getCampaignList()
    },
    methods: {
        getCampaignList () {
            CampaignService.getCampaigns(10, 1, null, this.searchKey).then(response => {
                this.campaignList = response.data.data
            })
        },
        exportProjectUser () {
            AdminService.exportCampaignUser(this.campaign)
        }
    },
    watch: {
        searchKey () {
            this.getCampaignList()
        }
    }
}
</script>

<style scoped lang="scss">
.AdminProject {
}
</style>
